module.exports = __webpack_public_path__ + "img/ketepatan_pekerjaan.4feb8d26.png";